var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("アンケートを回答しました。")))]),_c('br'),_c('router-link',{attrs:{"to":{ name: 'surveys' }}},[_vm._v(_vm._s(_vm.$t("アンケートへ")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }